import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { setInternetCampaign } from 'src/features/client/InStore';

export const useMarketingMappingQuery = () => {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);

    const internetReferenceCampaign = queryParams.get('cref');
    const internetProviderCampaign = queryParams.get('cprovider');

    if (internetProviderCampaign && internetReferenceCampaign) {
      dispatch(
        setInternetCampaign({
          internetProviderCampaign,
          internetReferenceCampaign: internetReferenceCampaign,
        }),
      );
    }
  }, [location, dispatch]);
};
